export default function DriverAddress() {

  return (
      <p>آدرس های راننده</p>
  );
};